module.exports = __webpack_public_path__ + "static/img/kjdy_dr_done.a279dfe.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdd/kjdy_dr_done.jpeg
// module id = 1229
// module chunks = 0